import { Link } from 'react-router-dom';

export const NotFound = () => {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <h1 className="text-[120px] font-bold leading-none text-primary-500">404</h1>
      <h2 className="mt-4 text-2xl font-semibold text-text-primary">
        Strona nie została znaleziona
      </h2>
      <p className="mt-2 max-w-md text-gray-500">
        Przepraszamy, ale strona której szukasz nie istnieje lub została przeniesiona.
      </p>
      <Link
        to="/"
        className="mt-8 rounded-lg bg-primary-500 px-6 py-3 font-medium text-white transition-colors hover:bg-primary-600"
      >
        Wróć na stronę główną
      </Link>
    </div>
  );
};
